import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Hero from "./components/Hero";
import QuickActions from "./components/QuickActions";
import QuoteOptions from "./components/QuoteOptions";
import InsuranceProducts from "./components/InsuranceProducts";
import HappyCustomers from "./components/HappyCustomers";
import InsurancePartners from "./components/InsurancePartners";
import WhyChooseUs from "./components/WhyChooseUs";
import ServiceStates from "./components/ServiceStates";
import PetInsurance from "./components/PetInsurance";
import BlogSection from "./components/BlogSection";
import Resources from "./components/Resources";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import AutoInsurance from "./components/AutoInsurance";
import BusinessInsurance from "./components/BusinessInsurance";
import HomeInsurance from "./components/HomeInsurance";
import LifeInsurance from "./components/LifeInsurance";
import BondsInsurance from "./components/BondsInsurance";
import CommercialAutoInsurance from "./components/CommercialAutoInsurance";
import TruckingInsurance from "./components/TruckingInsurance";
import TravelInsuranceDetail from "./components/TravelInsuranceDetail";
import PetInsuranceDetail from "./components/PetInsuranceDetail";
import WarrantyInsurance from "./components/WarrantyInsurance";
import OurAgents from "./components/OurAgents";
import CustomerService from "./components/CustomerService";
import ReviewsSection from "./components/ReviewsSection";
import FAQPage from "./components/FAQPage";
import FAQHomeSection from "./components/FAQHomeSection";
import ChatbotWidget from "./components/ChatbotWidget";
import PaymentPage from "./components/PaymentPage";
import JoinOurTeam from "./components/JoinOurTeam";
import AutoQuotePage from "./components/AutoQuotePage";

const Home = () => {
  return (
    <>
      <Hero />
      <QuickActions />
      <QuoteOptions />
      <InsuranceProducts />
      <ReviewsSection />
      <HappyCustomers />
      <FAQHomeSection />
      <InsurancePartners />
      <WhyChooseUs />
      <ServiceStates />
      <PetInsurance />
      <BlogSection />
      <Resources />
      <Newsletter />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products/auto" element={<AutoInsurance />} />
            <Route path="/products/business" element={<BusinessInsurance />} />
            <Route path="/products/home" element={<HomeInsurance />} />
            <Route path="/products/life" element={<LifeInsurance />} />
            <Route path="/products/bonds" element={<BondsInsurance />} />
            <Route path="/products/commercial-auto" element={<CommercialAutoInsurance />} />
            <Route path="/products/trucking" element={<TruckingInsurance />} />
            <Route path="/products/travel" element={<TravelInsuranceDetail />} />
            <Route path="/products/pet" element={<PetInsuranceDetail />} />
            <Route path="/products/warranty" element={<WarrantyInsurance />} />
            <Route path="/agents" element={<OurAgents />} />
            <Route path="/customer-service" element={<CustomerService />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/join-our-team" element={<JoinOurTeam />} />
            <Route path="/quote/auto" element={<AutoQuotePage />} />
          </Routes>
          <Footer />
          <ChatbotWidget />
          <Toaster />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
